import React from 'react';

import { Button, Form } from 'components';

import styles from './styles.scss';

export default class Widget extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      canSubmit: false,
      name: '',
      birthday: '',
    };
  }

  onChange = e => {
    const input = e.currentTarget;
    const name = input.name;
    const value = input.value;

    this.setState({
      canSubmit: this.state.birthday && value,
      [name]: value,
    });
  };

  onDateChange = date => {
    this.setState({
      canSubmit: this.state.name && date,
      birthday: date,
    });
  };

  onSubmit = e => {
    e.preventDefault();

    const { canSubmit } = this.state;

    if (canSubmit) {
      this.form.submit();
    } else {
      p('cant Submit');
    }
  };

  render() {
    const { name, birthday, canSubmit } = this.state;

    return (
      <div className={styles.widget}>
        <form ref={c => (this.form = c)} method="GET" onSubmit={this.onSubmit}>
          <Form.Input
            name="name"
            label={kroostApp.strings.preferdName}
            value={name}
            placeholder="..."
            onChange={this.onChange}
          />

          <Form.DatePicker
            name="birthday"
            label={kroostApp.strings.dateOfBirth}
            value={birthday}
            onChange={this.onDateChange}
          />

          <Button onClick={this.onSubmit} disabled={!canSubmit}>
            {kroostApp.strings.makeYourBook}
          </Button>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/widget/index.js